<template>
  <v-footer
    class="px-4"
    align="center"
    color="#f0f0f0"
    style="background-color: #f0f0f0 !important;"
    :padless="true"
    dense
  >
    <v-col
      cols="1"
      class="footer-column text-left"
    >
      <a
        href="https://www.systemx.net"
        target="_blank"
      >
        <img
          :src="require('@/assets/systemx_MAIN_Colour_Black.svg')"
          style="height:30px"
          contain
        >
      </a>
    </v-col>

    <v-col class="footer-column text-center" />
    <v-col
      cols="5"
      class="footer-column text-right"
    >
      <v-row dense>
        <v-col>
          <v-select
            v-model="language"
            :items="languages"
            item-text="name"
            item-value="id"
            label="Language"
            dense
            hide-details
          />
        </v-col>
        <v-divider vertical />
        <v-col class="text-center">
          <v-row>
            <v-col class="pt-0 pb-0">
              <a
                href="https://www.systemx.net/terms-of-service"
                target="_blank"
              >Terms of Service</a>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <a
                href="https://www.systemx.net/privacy-policy"
                target="_blank"
              >Privacy Policy</a>
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical />
        <v-col class="text-center">
          Copyright &#169; {{ year }} SystemX
        </v-col>
      </v-row>
    </v-col>
  </v-footer>
</template>

<script>
import moment from 'moment';
export default {
  name: 'InvoiceFooter',
  data() {
    return {
      language: 1,
      languages: [{ id: 1, name: 'English' }],
     };
  },
  computed: {
    year() {
      return moment().format('yyyy');
    },
  },
  methods: { },
};
</script>
<style lang="scss" scoped>
.footer-column {
  padding-top: 5px;
  padding-bottom: 2px;
}
</style>
